import { Star } from "lucide-react";

/**
 * Star rating display. `value` is 0..5 (can be fractional).
 * If `onChange` is provided, becomes an interactive picker.
 * `size` is the icon size (default 14).
 */
export default function Stars({ value = 0, size = 14, onChange = null, testid = "" }) {
  const stars = [1, 2, 3, 4, 5];
  const interactive = typeof onChange === "function";
  return (
    <div className={`inline-flex items-center gap-0.5 ${interactive ? "cursor-pointer" : ""}`} data-testid={testid || undefined}>
      {stars.map((n) => {
        const filled = value >= n - 0.5;
        return interactive ? (
          <button
            type="button"
            key={n}
            onClick={() => onChange(n)}
            aria-label={`${n} stars`}
            data-testid={testid ? `${testid}-star-${n}` : undefined}
            className="p-0.5 leading-none"
          >
            <Star size={size} strokeWidth={1.5} className={filled ? "text-[#D4A648] fill-[#D4A648]" : "text-stone-300"} />
          </button>
        ) : (
          <Star key={n} size={size} strokeWidth={1.5} className={filled ? "text-[#D4A648] fill-[#D4A648]" : "text-stone-300"} />
        );
      })}
    </div>
  );
}
